var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status === 'NONE')?_c('div',{staticClass:"image"}):_c('battery',{staticClass:"image",class:_vm.status})}
var staticRenderFns = []

export { render, staticRenderFns }